import type { AnimateLayoutChanges } from '@dnd-kit/sortable';
import { defaultAnimateLayoutChanges, useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import type { ContainerProps } from 'components/DragAndDrop/components';
import { Container2 } from 'components/DragAndDrop/components';
import { ECreateQuestionMode } from 'components/Questionsv2/builder/context/create-question.context';
import type { CSSProperties, ReactNode } from 'react';
import { useState } from 'react';
import { EQuestionType } from '@hubertai/screening-question-types';
import type { TSortableContainerItem } from '..';

import { useAppSelector } from 'rtk/query/hooks';
import { selectQuestionIsReadonly, selectQuestionMode } from 'rtk/questionEditorSelector';
import { useQuestionEditorContext } from 'components/Questionsv2/builder/context/create-question.context';

const animateLayoutChanges: AnimateLayoutChanges = (args) =>
  defaultAnimateLayoutChanges({ ...args, wasDragging: true });

const DroppableContainer2 = ({
  container,
  containerId,
  headerContent,
  children,
  columns = 1,
  style,
  ...props
}: ContainerProps & {
  container: TSortableContainerItem;
  containerId: string;
  headerContent?: ReactNode;
  style?: CSSProperties;
}) => {
  const { questionId } = useQuestionEditorContext();
  const mode = useAppSelector((state) => selectQuestionMode(state, questionId));
  const type = useAppSelector((state) => state.questionEditor.byId[questionId].type);
  const isReadOnly = useAppSelector((state) => selectQuestionIsReadonly(state, questionId));

  const [readonly] = useState<boolean>(
    isReadOnly ||
      (mode === ECreateQuestionMode.InTemplateEdit && containerId === 'text' && type !== EQuestionType.Info),
  );

  const { active, attributes, isDragging, listeners, over, setNodeRef, transition, transform } = useSortable({
    id: containerId,
    data: {
      type: 'container',
      children: (container && container.items) ?? [],
    },
    animateLayoutChanges,
    disabled: readonly,
  });

  const isOverContainer = over
    ? containerId === over.id && active?.data.current?.type !== 'container'
    : // || items.includes(over.id)
      false;

  return (
    <Container2
      ref={readonly ? undefined : setNodeRef}
      style={{
        ...style,
        transition,
        transform: CSS.Translate.toString(transform),
        opacity: isDragging ? 0.5 : undefined,
      }}
      hover={isOverContainer}
      handleProps={{
        ...attributes,
        ...listeners,
      }}
      disabled={true}
      columns={columns}
      {...props}
      headerContent={
        // headerContent ? headerContent(container): undefined
        headerContent ? headerContent : undefined
      }
    >
      {children}
    </Container2>
  );
};

export default DroppableContainer2;
